import { isFinanceProject, isGlobalProject } from 'config';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { CitizenshipFormType, citizenshipsSchema } from './citizenshipForm';
import { ControlOverFormType, getControlOverSchema } from './controlOverForm';
import {
  PepConnectionFormType,
  getPepConnectionSchema,
} from './pepConnectionForm';
import {
  PersonalDataFormType,
  getPersonalDataSchema,
} from './personalDataForm';
import { PlaceOfBirthFormType, placeOfBirthSchema } from './placeOfBirthForm';
import {
  RegistrationAddressFormType,
  registrationAddressSchema,
} from './registrationAddressForm';
import {
  ResidentialAddressFormType,
  residentialAddressWithFilesSchema,
} from './residentialAddressForm';
import {
  TaxResidencyFormType,
  getTaxResidencesSchema,
} from './taxResidencyForm';

export interface LegalClientBeneficiaryFormType
  extends ControlOverFormType,
    PersonalDataFormType,
    CitizenshipFormType,
    TaxResidencyFormType,
    PlaceOfBirthFormType,
    RegistrationAddressFormType,
    ResidentialAddressFormType,
    PepConnectionFormType,
    ReasonChangeFormType {}

export const getSchema = (
  t: TFunc
): ObjectSchema<LegalClientBeneficiaryFormType> => {
  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();
  return object()
    .concat(getPersonalDataSchema(t))
    .concat(citizenshipsSchema)
    .concat(getTaxResidencesSchema())
    .concat(placeOfBirthSchema)
    .concat(applySchema(isFinance, registrationAddressSchema))
    .concat(residentialAddressWithFilesSchema)
    .concat(
      getControlOverSchema({
        enabledControlOverLegalClientStatus: isGlobal,
        enabledFinancialConditionAmount: isFinance,
        enabledHasControlOverLegalClient: isFinance,
      })
    )
    .concat(getPepConnectionSchema(t, { notRequestInformation: isGlobal }))
    .concat(reasonChangeSchema);
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientBeneficiaryFormType>();

export type FormErrors = FormErrorsBase<LegalClientBeneficiaryFormType>;
